import React, { Component, Suspense } from "react";
// import { Redirect } from "react-router-dom";
import { withTranslation } from "react-multi-lang";
import { withAlert } from "react-alert";
// import $ from "jquery";
import "bootstrap";

const Menu = React.lazy(() => import("./subpages/Menu.jsx"));
const Administratorheader = React.lazy(() => import("./subpages/Administratorheader.jsx"));
const HomeDocument = React.lazy(() => import("./subpages/HomeDocument.jsx"));

class AdministratorHomeDocument extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    }

    onlogout(e) {
        // store.dispatch(replacestate(defalutreduxState));
        setTimeout(() => { this.props.history.push("/administrator"); }, 100);
    }

    render() {

        return (
            <div id="idElnBody" className="adminPageContainer">
                <Suspense fallback={<div></div>}>
                    <Menu />
                </Suspense>
                <div id="bodycontent" className="d-flex flex-column">
                    <Suspense fallback={<div></div>}>
                        <Administratorheader
                            pageName={this.props.t("Organisation.IDS_LBL_HOMEDOCUMENT")} onlogout={this.onlogout.bind(this)} />
                    </Suspense>
                    <Suspense fallback={<div></div>}>
                        <HomeDocument />
                    </Suspense>

                </div>
            </div>
        );
    }
}
export default withAlert()(withTranslation(AdministratorHomeDocument));